import { Pipe, PipeTransform } from '@angular/core';
import { abbreviateNumber } from '../../helpers/formatting/number.helper';

/**
 * Takes a positive integer number and converts it to 3 digits + a letter suffix (K, M, B, T, Q)
 *
 * @note Don't use this for negative values, or numbers greater than 10^18
 */
@Pipe({
    name: 'significantDigits',
    standalone: false
})
export class SignificantDigitsPipe implements PipeTransform {

    readonly characterLimit = 3;

    transform(value: any, args?: any): any {
        return abbreviateNumber(value, args);
    }
}
